import { gql } from 'graphql-request';

const DeleteAnnotationMutation = gql`
  mutation DeleteAnnotation($story_id: ID, $annotation_id: ID) {
    delete_annotation(story_id: $story_id, annotation_id: $annotation_id) {
      __typename

      ... on delete_annotation_response {
        deleted_annotation {
          id
        }

        updated_correlations {
          row_index
          annotation_ids
        }
      }

      ... on i_error {
        message
      }
    }
  }
`;

export default DeleteAnnotationMutation;
